module.exports = __webpack_public_path__ + "static/media/Samsung_Pay_Logo.8be60f48.svg";